import { Injectable } from '@angular/core';
import { CrudService } from '../crud/crud.service';
import { ApiResponse } from '../../models/response-api';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }

  private messageSentSubject: BehaviorSubject<void | null> =
    new BehaviorSubject<void | null>(null);

  getMessageSentObservable() {
    return this.messageSentSubject.asObservable();
  }

  sendMessage(id: any, message: string, emitterRole : string | null, receiverRole: string | null) {
    const formData = new FormData();
    formData.append('message', message);
    return this._http
      .post<any>(`${this._base}/candidate/Chat/sendMessage?id=${id}`, 
        { message, emitter_role :  emitterRole, receiver_role : receiverRole})
      .pipe(tap(() => this.messageSentSubject.next(null)));
  }

  getMessagesEmitter(id: any, roleConnected: any, roleReceiver : any) {
    return this._http.get<any>(
      `${this._base}/candidate/Chat/getMessagesBetweenUsers?id=${id}&role_connected=${roleConnected}&role_receiver=${roleReceiver}`
    );
  }

  getListUsers() {
    return this._http.get<any>(
      `${this._base}/candidate/Chat/listUsers?per_page=100+&page=1`
    );
  }

  deleteConversation(receiverId: number) {
    return this._http.delete(this._base + `/candidate/Chat/deleteDiscussion`, {
      params: {
        receiver_id: receiverId.toString(),
      },
    });
  }

  readMessage(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/candidate/Chat/markMessageAsRead`,
      data
    );
  }

  searchListUser(data: any, perPage : number, page : number) {
    return this._http.post<any>(
      `${this._base}/admin/Chat/searchUserForAdmin?per_page=${perPage}&page=${page + 1}`,
      data
    );
  }

  searchListMessage(data: any, perPage : number, page : number) {
    return this._http.post<any>(
      `${this._base}/admin/Chat/searchInMessages?per_page=${perPage}&page=${page + 1}`,
      data
    );
  }

  getListMessage() {
    return this._http.get<any>(`${this._base}/candidate/Chat/getMessagesByUser`);
  }
  getUsers() {
    return this._http.get<any>(`${this._base}/candidate/Chat/getUser`);
  }
  headerClass: string = '';

  setHeaderClass(className: string): void {
    this.headerClass = className;
  }

  getHeaderClass() {
    return this.headerClass;
  }

  getUnreadMessage(roleConnected: any) {
    return this._http.get<any>(`${this._base}/Chat/fetchMessagesReceiver?role_connected=${roleConnected}`);
  }
}
